import RoleDelete from './RoleDelete';

export default RoleDelete;
